import EmailSendLimitModal from './EmailSendLimitModal';

export default EmailSendLimitModal;
